export default __webpack_public_path__ + "static/media/blog-img98.6b33ec47.jpg";